import './TextInputInnerAction-b406c147.css';

var styles = {"Invisible":"prc-components-Invisible-uIWry"};

export { styles as default };
